// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
// urls for dev
  // baseUrl:'https://api.dev-new.afr4.0.livnsense.com/',
  // baseUrl2:'https://api.dev-new.afr4.0.livnsense.com/',
  // baseUrl3:'https://api.dev-new.cement4.0.livnsense.com/',
  // lnsURL: 'https://api.dev-new.afr4.0.livnsense.com/',

  baseUrl:'https://api-afr4.0.livnsense.com/',
  baseUrl2:'https://api-afr4.0.livnsense.com/',
  baseUrl3:'https://api-pyro4.0.livnsense.com/',
  lnsURL: 'https://api-afr4.0.livnsense.com/',
  
  // urls for production
  // baseUrl:'https://api.afr4.0.livnsense.com/',
  // baseUrl2:'https://api.afr4.0.livnsense.com/',
  // lnsURL: 'https://api.afr4.0.livnsense.com/',
  // lnsURL: 'http://localhost:4200/#/dashboard/landingpage'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
